import React from 'react';

const DescriptionFields = ({
  oldData, 
  setDescription,
}) => {

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Краткая характеристика (описание на 300-500 символов)
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.description}
          placeholder='Общая характеристика'
          onChange={e => { setDescription(e) }}
      />
    </>
  );
};

export default DescriptionFields;